//import { Email } from '@material-ui/icons';
import {Component} from 'react';
import { connect } from 'react-redux';
import { setInfo } from '../../redux/actionList';
import RegisterForm from './register_form';
import ForgotPassword from './forgot_password';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import WaitTimeSpinner from '../shared-components/wait_time_spinner';
import buildUrl from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import ConfigFile from '../../datasets/config_file';
import withRouterCompat from '../../objects/CommonUse/with_router_compat';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import getCurrentDateTime from '../../objects/CommonUse/get_current_date_time';
import setTempTokenForFetch from '../../objects/CommonUse/set_temp_token_for_fetch';

// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    gameInfo: state
    // add other Redux state slices here if needed
});

// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
};

class LoginForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            test: false,
            loginLoaded: false,
            userQuestionLoaded: false,
            accountLoaded: false,
            environment: Config.dataURL.currentEnv,
            hidePassword: true,
            waitState: false,
        };
        this.processRequested = "LoginForm";
        this.subProcess = "LoginForm";
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handleRegister = this.handleRegister.bind(this);
        this.handleClickShowPassword = this.handleClickShowPassword.bind(this);
        this.formType = "password";
        this.signonType = "";
        console.log("LoginForm")
        this.setProcessRequested();
    }

    setProcessRequested(){
        if (this.props.loginObj){
            this.processRequested = "ConfirmLoginObj";
            this.setState({waitState: true});
            this.errorMessage = "";
            this.username = this.props.loginObj.userName;
            this.password = this.props.loginObj.password;
            this.rqstType = "VerifyUserPassword";
            this.getLogin();
        }else{
            this.processRequested = "LoginForm";
        }
    }

    onNavigate = (path) => {
        const { navigate, location } = this.props;
        // Only navigate if we aren’t already there
        if (location.pathname !== path) {
            navigate(path, { replace: true });
        }
    };

    render() { 
        if (this.state.loginLoaded === true && 
            (this.processRequested === "LoginForm" || this.processRequested === "ConfirmLoginObj")){
            this.processSubmit();  
        }
    
        return <>
            
            {this.processRequested === "LoginForm" ?               
                <span>
                {this.state.waitState   ?
                    <div >
                        <WaitTimeSpinner/>
                    </div>
                :               
                    <form className="login-form px-2 pb-2" id="loginForm" onKeyPress={this.handleKeyPress}>
                        <div className="font-weight-bold mb-2">Must be logged in to access this selection:</div>
                        <div className="form-group text-left">
                            <label className="font-weight-bold">Username</label>
                            <input type="username" className="form-control" id="usernameInput" size="50"
                                placeholder="Enter username"/>
                        </div>
                        <div className="form-group">
                            <span className="row w-100">
                                <span className="col-sm-8 mt-2 text-left">
                                    <label className="font-weight-bold">Password</label>
                                </span>
                                <span className="col-sm-4 text-right pr-0">
                                    <IconButton  onClick={this.handleClickShowPassword} edge="end">
                                        {this.state.hidePassword ? <VisibilityOff /> : <Visibility /> }
                                    </IconButton>
                                </span>
                            </span>
                            <input type={this.formType} className="form-control" id="passwordInput" size="50"
                                placeholder="Enter password" autoComplete="new password" />
                               
                        </div>
                        <div className="row">
                            <button type="button" className="btn btn-primary ml-4" 
                                onClick={()=>this.handleSubmit()}>Log in</button>
                            <span className="text-pointer ml-4">
                                <span onClick={()=>this.handleForgotPassword()}>Forgot Password</span>
                            </span>
                        </div>
                        <div className="text-danger font-weight-bold">{this.errorMessage}</div>
                        <div>
                            <div className="text-center lighter-blue font-weight-bold">
                                -------------  OR  -----------------
                            </div>
                            <div className="font-weight-bold ml-2">
                                If you do not currently have a SignOn for the game...
                            </div>
                            <div className="mt-2">
                                <button type="button" className="ml-2 btn btn-info" 
                                    onClick={()=>this.handleRegister("individual")}>
                                    &nbsp; Create Individual SignOn &nbsp;</button>
                            </div>
                            <div className="mt-2">
                                <button type="button" className="ml-2 btn btn-info" 
                                    onClick={()=>this.handleRegister("group")}>
                                        Create Class/Family SignOn</button>
                            </div>
                        </div>
                    
                    </form>
                }

                </span>
            :
                null
            }
            {this.processRequested === "RegisterForm" ?
                <RegisterForm
                    openModal={this.state.openModal}
                    signonType={this.signonType}
                    registerComplete={(credentials) => this.confirmLogin(credentials)}
                    closeForm={() => this.closeLoginForm()}
                    processError = {(errorObj) => this.processErrorReturn(errorObj)}
                />    
            :
                null
            }
        
            {this.processRequested === "ForgotPassword" ?
                <ForgotPassword
                    loginLoaded={this.state.loginLoaded}
                    securityQuestion={this.securityQuestion}
                    securityAnswer={this.securityAnswer}
                    username={this.username}
                    passwordResetComplete={(credentials) => this.confirmLogin(credentials)}
                    closeForm={() => this.closeLoginForm()}
                    processError = {(errorObj) => this.processErrorReturn(errorObj)}
                />
            :
                null
            }
   
        </>
    }

    componentWillUnmount(){
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state,callback)=>{
            return;
        };
    }
    
    handleClickShowPassword(){
        if (this.state.hidePassword === false){
            this.formType = "password";
        }else{
            this.formType = "showPassword";
        }
        this.setState({hidePassword: !this.state.hidePassword});
    }

    handleSubmit()
    {
        this.setState({waitState: true});
        this.errorMessage = "";
        this.username = document.getElementById("usernameInput").value;
        if (this.username === "") document.getElementById("usernameInput").classList.add("is-invalid");

        this.password = document.getElementById("passwordInput").value;
        if (this.password === "") document.getElementById("passwordInput").classList.add("is-invalid");

        if (this.password === "" || this.username === ""){
            this.errorMessage = "Invalid Username or Password";
            this.setState({waitState: false});
        }else{ 
            this.rqstType = "VerifyUserPassword";
            this.getLogin();
        }
    }    

    clearErrorMsg(){
        this.errorMessage = "";
    }
    
    processSubmit(){
        if (this.loginInfo.message && this.loginInfo.message === "Authentication failed")
        {
            this.errorMessage = "Invalid Username or Password";
        }else{
            this.setSessionStorage();
          //  the following call causes an error - trying to modify state within render
            this.props.onSuccessfulLogin(this.loginInfo.username, this.loginInfo.role);
            this.onNavigate("");
        }
    }

    setSessionStorage(){
        sessionStorage.setItem('username', this.loginInfo.username);
        sessionStorage.setItem('userRole', this.loginInfo.role);
        let accountNbr = this.loginInfo.accountNbr;
        sessionStorage.setItem('userAccountNbr', accountNbr);
        sessionStorage.setItem('defaultUserAccount', accountNbr);
        this.props.setInfoRedux(this.loginInfo.role, "playerRole");
    }

    handleKeyPress(e)
    {
        if(e.key === "Enter")
        {
            this.handleSubmit();
        }
    }
    
    handleRegister(signonType){
        this.signonType = signonType;
        this.processRequested = "RegisterForm";
        this.setState({test: true});
    }

    handleForgotPassword(){
        this.username = document.getElementById("usernameInput").value;
        if (this.username === ""){ 
            document.getElementById("usernameInput").classList.add("is-invalid");
        }else{
            this.setState({waitState: true})
            this.setState({test: true});
            this.rqstType = "UserQuestion";
            this.getLogin();
            
        }
    }

    confirmLogin(credentials){
        if (credentials !== null){
            this.rqstType = "VerifyUserPassword";
            this.processRequested = "LoginForm";
            this.username = credentials.username;
            this.password = credentials.password;
            this.getLogin();
        }else{
            alert ("oops!  The username and password were not saved successfully. " +
               "Please try again.")
            this.processRequested = "LoginForm";
            this.setState({loginLoaded: false});
        }
    }

    closeLoginForm(){
        this.processRequested = "LoginForm";
        this.setState({loginLoaded: false});
    }
     
    getLogin(){
        this.setState({loginLoaded: false});
        let headers = setTempTokenForFetch(this.username, this.password);
        const funcName = "loginChk";
        const urlParm = "?rqstType=" + this.rqstType;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {method:'GET',
             headers: headers
            })
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                        const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                        if (statusCode === 200){
                            this.loginInfo = output.body;
                            if (this.loginInfo.userToken){
                                const token = this.loginInfo.userToken;
                                const dateAndTime = getCurrentDateTime();
                                const tokenStorage = 
                                    {token: token, dateTime: dateAndTime.dateTime, process: "" };
                                sessionStorage.setItem('sessionToken', JSON.stringify(tokenStorage));
                                if (this.loginInfo.accountNbr !== "Individual"){
                                    this.accountNbr = this.loginInfo.accountNbr;
                                    this.getAccount();
                                }
                            }else{
                                if (this.rqstType === "UserQuestion"){
                                    if (this.loginInfo.securityQuestion){
                                        this.securityQuestion = this.loginInfo.securityQuestion;
                                        this.securityAnswer = this.loginInfo.securityAnswer;
                                        this.processRequested = "ForgotPassword";
                                    }
                                }
                            }
                            if (this.loginInfo.result){
                                this.errorMessage = this.loginInfo.result;
                                this.processRequested = "LoginForm";
                            }
                            this.setState({waitState: false, loginLoaded: true});
                        }else{
                            const parmObj={rqstType: this.rqstType, username: this.username};
                            const errorObj={function: funcName, subProcess: this.subProcess, 
                                status: statusCode, message: output.body.message, errorObject: parmObj};
                            this.processErrorReturn(errorObj);
                        }
                });
            }
        });
    }

getAccount(){
    let headers = setHeadersForFetch();
    const funcName = "loadAccount";
    const urlParm = "?accountNbr=" + this.accountNbr + "&tokenType=RealToken";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,
        {method:'GET',
            headers: headers,
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.accountInfo = output.body;
                        this.accountFound = true;
                        this.determineAccountType();
                        this.setState({accountLoaded: true});
                    }else{
                        if (statusCode === 250){
                            this.accountFound = false;
                            this.setState({accountLoaded: true});
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message};
                            this.props.processError(errorObj);
                        }
                    }
                });
            };
        })
}
    
determineAccountType(){
    for (let i=0; i<this.accountInfo.rqstdUsersArr.length; i++){
         let userObj = this.accountInfo.rqstdUsersArr[i];
         if (this.accountInfo.accountNbr === ConfigFile.general.demoAccount){
            this.accountType = "demo";
            sessionStorage.setItem("accountType", this.accountType);
            break;
         }else{
            if (userObj.role === "teacher" || userObj.role === "parent"){
                this.accountType = userObj.role;
                sessionStorage.setItem("accountType", this.accountType);
                break;
            }
         }
    }
}
     
processErrorReturn(errorObj){
    this.addRecordToLogfile(errorObj);
    if (!errorObj.silentAlert || errorObj.silentAlert === false){
        alert ("Uh oh!  Something unexpected has occurred " +
            "error has been logged and will be addressed. " +
            "For now click OK, then return to the process " +
            "where you were and try again.");
        this.onNavigate("");
    }
}

addRecordToLogfile(errorObj){
    console.log("errorObj is: ", errorObj);
    if (errorObj.status === 250){
        errorObj.message = "No record found";
    }
    let urlParm = "";
    let headers = "";
    const authToken = JSON.parse(sessionStorage.getItem('sessionToken'));
    if (authToken === null){
        headers = setTempTokenForFetch(this.username, this.password);
    }else{
        headers = setHeadersForFetch();
    }  
    if (!errorObj.errorObject){
        errorObj.errorObject = {info: "no error object provided"};
    }
    const logFileBody =  {
        mainProcess: "login",
        subProcess: errorObj.subProcess,
        function: errorObj.function,
        status: errorObj.status,
        message: errorObj.message,
        errorObj: errorObj.errorObject
    }
    console.log("logFileBody is: ", logFileBody);
    let funcName = "saveLogFile"; 
   
    const uri = buildUrl(this.state.environment, funcName, urlParm)
    fetch (uri,  
        {method: 'POST', 
         headers: headers, 
         body: JSON.stringify(logFileBody)}
        )
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        console.log("logfile create was successful");
                    }else{
                        alert ("Response from save log file not valid!" +
                            " status is: " + statusCode +
                            " message is: " + output.body.message)
                       
                    }
            });
        }
    });
  
}

   
}

export default connect(mapStateToProps, mapDispatchToProps) (withRouterCompat(LoginForm));